import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import classnames from 'classnames';
import Modal from 'react-bootstrap/lib/Modal';
import TabsAccount from 'User/Account/TabsAccount';
import {isNative} from '../ferries/helpers/common';
import {userAccountTranslations} from 'User/helpers/translations';
import loginIllustration from 'User/helpers/images/login-illustration.svg';
import registerllustration from 'User/helpers/images/register-illustration.svg';

const {loginSlogan, login, register, whyAccount, accountReasons} = userAccountTranslations;

const AccountModal = ({isMobile, email, classes, children}) => {
  const [showModal, setShowModal] = useState(false);
  const [tabIndexSelected, setTabIndexSelected] = useState(0);

  useEffect(() => {
    if (!isNative()) return;
    const tp24Id = sessionStorage.getItem('tp24Id') || '';
    if (!tp24Id) return;
    const fixedHref = window.location.href.replace(/^([^?#]*)&/, '$1?');
    const currentUrl = new URL(fixedHref);
    if (!currentUrl.searchParams.has('tp24Id')) {
      currentUrl.searchParams.set('tp24Id', tp24Id);
      window.history.replaceState({}, '', currentUrl.toString());
    }
  }, []);

  const onChangeTab = (index) => {
    setTabIndexSelected(index);
  };

  const toggleModal = (tabIndex) => {
    if (isNative()) {
      const tp24Id = sessionStorage.getItem('tp24Id') || '';
      const fixedHref = window.location.href.replace(/^([^?#]*)&/, '$1?');
      const currentUrl = new URL(fixedHref);
      currentUrl.searchParams.set('loginOnMobile', tp24Id || 'true');
      window.history.replaceState({}, '', currentUrl);
      return;
    }

    setShowModal((showModal) => !showModal);
    if ([0, 1].includes(tabIndex)) {
      setTabIndexSelected(tabIndex);
    }
  };

  const onClickAccount = (e) => {
    const el = e.target.closest('a');
    if (el && e.currentTarget.contains(el)) {
      e.preventDefault();
      setTabIndexSelected(parseInt(el.getAttribute('tab')));
      toggleModal();
    }
  };

  const childrenClasses = classnames('position-relative', {
    'bg-white': isMobile
  });

  return (
    <div className={classnames(classes)}>
      <div>
        {children(toggleModal, onClickAccount)}
      </div>
      <Modal
        dialogClassName="user-login-modal"
        bsSize="lg"
        show={showModal}
        onHide={toggleModal}
      >
        <div className={childrenClasses}>
          <div className="position-absolute" style={{top: 26, right: 20, zIndex: 10}}>
            <button type="button" className="close" onClick={toggleModal}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="grid no-gutter">
            {!isMobile &&
              <div
                className="grid-item-auto bg-primary position-relative px-5 "
                style={{borderRadius: '24px 0 0 24px', width: '340px'}}
              >
                {tabIndexSelected === 0 ? <>
                  <div
                    className="text-center text-white mt-6 font-bold"
                    style={{fontSize: '56px'}}
                  >
                    {loginSlogan}
                  </div>
                  <img
                    className='position-absolute w-1-1'
                    style={{bottom: 0, left: 0}}
                    src={loginIllustration}
                    width="95%"
                    role="login-illustration"
                    alt={login}
                    title={login}
                  />
                </> :
                  <div>
                    <img src={registerllustration}
                      className="mt-6 mb-4"
                      width="115%"
                      height="100%"
                      role="register-illustration"
                      title={register}
                      alt={register}
                    />
                    <div className="px-5 mb-6">
                      <div className="display-4 font-bold mb-2">{whyAccount}</div>
                      <div>{accountReasons}</div>
                    </div>  
                  </div>
                }
              </div>
            }
            <div className="px-4 py-3 grid-item">
              <TabsAccount
                isModal
                tabIndexSelected={tabIndexSelected}
                email={email}
                onChangeTab={onChangeTab}
              />
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

AccountModal.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  email: PropTypes.string,
  classes: PropTypes.string,
  children: PropTypes.func.isRequired
};

export default observer(AccountModal);
